module.exports = __webpack_public_path__ + "static/patience_sign.3e584c73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_stories/_patience/patience_sign.jpg
// module id = 912
// module chunks = 41691937990162